import {$generateNodesFromDOM} from '@lexical/html';
import {$getRoot,$getSelection,$isRangeSelection,$createParagraphNode,$isElementNode,$isDecoratorNode} from 'lexical';
import {$createPageNode} from '../nodes/PageNode.jsx';
import {sanitize} from './sanitize';
import {restoreSelection} from './selection';
export function insertImportedHtml(editor,html,mode,selection){
 const clean=sanitize(html,'load');
 editor.update(()=>{
  const nodes=$generateNodesFromDOM(editor,new DOMParser().parseFromString(clean,'text/html')),blocks=[];
  nodes.forEach(n=>{if(($isElementNode(n)||$isDecoratorNode(n))&&!n.isInline())blocks.push(n);else{const p=$createParagraphNode();p.append(n);blocks.push(p);}});
  if(mode==='replace'){const root=$getRoot();root.clear();const p=$createPageNode();root.append(p);p.append(...blocks);if(!blocks.length)p.append($createParagraphNode());p.selectEnd();}
  else{restoreSelection(selection);const s=$getSelection();if(!$isRangeSelection(s))throw new Error('Click inside the document before using Insert at cursor.');s.insertNodes(blocks);}
 },{discrete:true,tag:'history-push'});editor.focus();
}
